import axios from "axios";

const adminAxios = axios.create();
const contarctAxios = axios.create();
const sinistreAxios = axios.create();

adminAxios.defaults.baseURL = 
"https://be.garanty.tn:8443/garantie-api-admin/v1";
//  "http://158.69.116.108:8080/garantie-api-admin/v1";

adminAxios.interceptors.response.use(
  function (response) {
    // //console.log("--->", response);
    return response;
  },
  function (error) {
    ////console.log(error);
    // return <Redirect to="pages/errors/error500"></Redirect>;

    return Promise.reject(error);
  }
);

adminAxios.interceptors.request.use(
  function (request) {
    const isLogged = JSON.parse(localStorage.getItem("user"));
    if (isLogged?.token) {
      request.headers.common.Authorization = `Bearer ${isLogged.token}`;
      return request;
    }else{
      return request;
    }
  },
  function (error) {
    ////console.log(error);
    // return <Redirect to="pages/errors/error500"></Redirect>;

    return Promise.reject(error);
  }
);

contarctAxios.defaults.baseURL =
  "https://be.garanty.tn:8443/garantie-api-contract/v1";
//  "http://158.69.116.108:8080/garantie-api-contract/v1";

contarctAxios.interceptors.response.use(
  function (response) {
    // //console.log("--->", response);
    return response;
  },
  function (error) {
    ////console.log(error);
    // return <Redirect to="pages/errors/error500"></Redirect>;

    return Promise.reject(error);
  }
);

contarctAxios.interceptors.request.use(
  function (request) {
    const isLogged = JSON.parse(localStorage.getItem("user"));
    if (isLogged?.token) {
      request.headers.common.Authorization = `Bearer ${isLogged.token}`;
      return request;
    }else{
      return request;
    }
  },
  function (error) {
    ////console.log(error);
    // return <Redirect to="pages/errors/error500"></Redirect>;

    return Promise.reject(error);
  }
);

sinistreAxios.defaults.baseURL =
  "https://be.garanty.tn:8443/garantie-api-sinistre/v1";
//  "http://158.69.116.108:8080/garantie-api-sinistre/v1";

sinistreAxios.interceptors.response.use(
  function (response) {
    // //console.log("--->", response);
    return response;
  },
  function (error) {
    ////console.log(error);
    // return <Redirect to="pages/errors/error500"></Redirect>;

    return Promise.reject(error);
  }
);

sinistreAxios.interceptors.request.use(
  function (request) {
    const isLogged = JSON.parse(localStorage.getItem("user"));
    if (isLogged.token) {
      request.headers.common.Authorization = `Bearer ${isLogged.token}`;
      return request;
    }else{
      return request;
    }
  },
  function (error) {
    ////console.log(error);
    // return <Redirect to="pages/errors/error500"></Redirect>;

    return Promise.reject(error);
  }
);

export { adminAxios, contarctAxios, sinistreAxios };
